module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realLaunch),
      expression: "realLaunch"
    }],
    staticClass: "modal-container row",
    class: {
      activated: _vm.launch
    },
    on: {
      "click": _vm.closeFromOutside
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.show) ? _c(_vm.content, {
    tag: "component",
    attrs: {
      "data": _vm.data
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97a20cbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/baseModal.vue
// module id = 649
// module chunks = 1